import { Injectable } from '@angular/core';
import { IFolder } from '@shared/constants/models.const';

@Injectable({
  providedIn: 'root',
})
export class CommunicationsDropdownService {
  selectedFolders: IFolder[] = [];
  selectedFoldersIds: number[] = [];
  isDropdownOpen = false;

  constructor() { }

  addItem(item: IFolder) {
    if (this.selectedFoldersIds.includes(item.id)) {
      this.removeItem(item);
    } else {
      this.selectedFolders.push(item);
      this.selectedFoldersIds.push(item.id);
    }
    this.isDropdownOpen = false;
  }

  removeItem(item: IFolder) {
    if (this.selectedFolders.indexOf(item) != -1 && this.selectedFoldersIds.indexOf(item.id) != -1) {
      this.selectedFolders.splice(this.selectedFolders.indexOf(item), 1);
      this.selectedFoldersIds.splice(this.selectedFoldersIds.indexOf(item.id), 1);
    }
  }
}
